import { useInfiniteQuery } from '@tanstack/react-query';

import { getAssistantSessionsBySessionIdMessages } from '@/api/generated/assistant/assistant';
import { queryKeys } from '@/config/query/queryKeys';

interface UseSessionHistoryOptions {
  enabled?: boolean;
  forceRefetchOnMount?: boolean;
  sessionId: string;
}

export const useSessionHistory = ({
  enabled = true,
  forceRefetchOnMount = false,
  sessionId,
}: UseSessionHistoryOptions) => {
  return useInfiniteQuery({
    enabled: enabled && !!sessionId,
    getNextPageParam: (lastPage) => {
      const messages = lastPage.messages;
      const hasMore = lastPage.hasMore ?? false;
      if (messages && messages.length > 0 && hasMore && messages[0]) {
        return messages[0].id;
      }
      return undefined;
    },
    initialPageParam: null as string | null | undefined,
    queryFn: ({ pageParam }: { pageParam: string | null | undefined }) =>
      getAssistantSessionsBySessionIdMessages(sessionId, {
        limit: 50,
        ...(pageParam ? { cursor: pageParam } : {}),
      }),
    queryKey: queryKeys.chat.session(sessionId),
    refetchOnMount: forceRefetchOnMount ? 'always' : false,
    refetchOnWindowFocus: false,
    staleTime: forceRefetchOnMount ? 0 : 5 * 60 * 1000,
  });
};
